import ImplementModule from './ImplementModule';

export default ImplementModule;
